import { useCallback } from 'react';
import {
  Box,
  Checkbox,
  CircularProgress,
  FormControl,
  Stack,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import distributionApi from 'services/api/distribution';
import { ReleaseSongFieldType } from 'services/store/distribution/types';
import { selectReleaseSongHasVocals } from 'services/store/distribution/selectors';
import { StyledCheckboxWrapper } from './styled';

type PropsType = {
  releaseId: string;
};

const HasVocalsCheckbox = ({ releaseId }: PropsType) => {
  const { t } = useTranslation();
  const hasVocalsCheckbox = useSelector(selectReleaseSongHasVocals(releaseId));
  const { data, loading } = hasVocalsCheckbox;

  const [updateReleaseSong] = distributionApi.useUpdateReleaseSongMutation();

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { checked: value } = event.target;
      updateReleaseSong({
        releaseId,
        field: ReleaseSongFieldType.HasVocals,
        value,
      });
    },
    [releaseId, updateReleaseSong]
  );

  return (
    <Stack direction="row" spacing={1} sx={{ alignSelf: 'flex-start' }}>
      <FormControl>
        <StyledCheckboxWrapper>
          {loading ? (
            <CircularProgress size={20} />
          ) : (
            <Checkbox checked={!!data} onChange={handleChange} />
          )}
        </StyledCheckboxWrapper>
      </FormControl>
      <Box sx={{ alignSelf: 'flex-start' }}>
        <Typography>
          {t('distribution:tracklist:fields:hasVocals:title')}
        </Typography>
      </Box>
    </Stack>
  );
};

export default HasVocalsCheckbox;
